<sgt-autocomplete
  [selectedItem]="{
    id: selectedCidade?.id,
    label: selectedCidade?.nome
  }"
  [settings]="settings"
  (changed)="onSearchCidade($event)"
>
  <ng-container item *ngIf="cidades && cidades.length">
    <li
      *ngFor="let cidade of cidades"
      class="autocomplete__item"
      (click)="onSelectCidade(cidade)"
    >
      <div class="d-flex flex-column">
        <span>
          {{ cidade?.nome }} - {{ cidade?.uf }}
        </span>
      </div>
    </li>
  </ng-container>
</sgt-autocomplete>
